import type { DeliveryTypes } from 'types';
import { Api } from '../fetch';

export class DeliveryNet {
  static get = (deliveryId: string) => Api.get<'delivery', 'get'>('/delivery/:deliveryId', { params: { deliveryId } });
  static load = (currentLast: Date, all?: boolean) =>
    Api.get<'delivery', 'load'>('/delivery/load', { query: { currentLast, all } });
  static sync = (lastSync: Date = new Date(0)) =>
    Api.get<'delivery', 'sync'>('/delivery/sync', { query: { lastSync } });
  static unstage = (deliveryId: string) =>
    Api.patch<'delivery', 'unstage'>('/delivery/unstage', { query: { deliveryId } });
  static unpack = (deliveryId: string) =>
    Api.patch<'delivery', 'unpack'>('/delivery/unpack', { query: { deliveryId } });
  static cancel = (deliveryId: string) =>
    Api.patch<'delivery', 'cancel'>('/delivery/cancel', { query: { deliveryId } });
  static comment = (body: DeliveryTypes['deliver']['comment']) =>
    Api.post<'delivery', 'comment'>('/delivery/comment', { body });
  static addTeamMember = (body: DeliveryTypes['deliver']['teamMember']) =>
    Api.patch<'delivery', 'addTeamMember'>('/delivery/team', { body });
  static removeTeamMember = (body: DeliveryTypes['deliver']['teamMember']) =>
    Api.delete<'delivery', 'removeTeamMember'>('/delivery/team', { body });
  static recordPayment = (deliveryId: string, body: DeliveryTypes['deliver']['payment']) =>
    Api.post<'delivery', 'recordPayment'>('/delivery/payment', { body, query: { deliveryId } });
  static complete = (deliveryId: string, body: DeliveryTypes['deliver']['complete']) =>
    Api.post<'delivery', 'complete'>('/delivery/complete', { body, query: { deliveryId } });
  static editCompleted = (deliveryId: string, body: DeliveryTypes['deliver']['editCompleted']) =>
    Api.post<'delivery', 'editCompleted'>('/delivery/complete/edit', { body, query: { deliveryId } });
  static addManualDelivery = (body: DeliveryTypes['deliver']['manual']) =>
    Api.post<'delivery', 'addManual'>('/delivery/manual', { body });
  static getManualDelivery = (id: string) => Api.get<'delivery', 'getManual'>('/delivery/manual', { query: { id } });
  static getManualDeliveries = (query: { take: number; skip: number }) =>
    Api.get<'delivery', 'getManual'>('/delivery/manual', { query });
  static getSignatureUrls = (deliveryId: string) =>
    Api.get<'delivery', 'getSignatureUrls'>('/delivery/signature/sign', { query: { deliveryId } });
  static getReceiptUrl = (deliveryId: string) =>
    Api.get<'delivery', 'getReceiptUrl'>('/delivery/receipt', { query: { deliveryId } });
  static truckStage = (deliveryId: string, body: DeliveryTypes['deliver']['truckLoad']) =>
    Api.post<'delivery', 'upsertTruckStage'>('/delivery/truck-stage', { body, query: { deliveryId } });
  static truckLoad = (deliveryId: string, body: DeliveryTypes['deliver']['truckLoad']) =>
    Api.post<'delivery', 'upsertTruckLoad'>('/delivery/truck-load', { body, query: { deliveryId } });
  static upsert = (body: DeliveryTypes['schedule']['delivery']) =>
    Api.post<'delivery', 'upsert'>('/delivery/upsert', { body });
}
